export default __webpack_public_path__ + "static/media/PRA_Wrong_Object-v3.4b136b62.wav";